export const PRODUCT_TYPE = {
	ROVO_COMPARISON_TOOL: 'rovoComparisonTool',
} as const;
export type PRODUCT_TYPE = (typeof PRODUCT_TYPE)[keyof typeof PRODUCT_TYPE];

export const EVENT_TYPE = {
	UI: 'ui',
	TRACK: 'track',
	SCREEN: 'screen',
	OPERATIONAL: 'operational',
} as const;
export type EVENT_TYPE = (typeof EVENT_TYPE)[keyof typeof EVENT_TYPE];

export const ANALYTIC_TYPE = {
	SEND_UI_EVENT: 'sendUIEvent',
	SEND_TRACK_EVENT: 'sendTrackEvent',
	SEND_SCREEN_EVENT: 'sendScreenEvent',
	SEND_OPERATIONAL_EVENT: 'sendOperationalEvent',
} as const;
export type ANALYTIC_TYPE = (typeof ANALYTIC_TYPE)[keyof typeof ANALYTIC_TYPE];

export const ANALYTICS_CHANNEL = 'sideBySide';

export const MODAL_ACTION = {
	CLOSED: 'closed',
	CANCELED: 'canceled',
	SUBMITTED: 'submitted',
};

export type MODAL_ACTION_TYPE = (typeof MODAL_ACTION)[keyof typeof MODAL_ACTION];

export type EntryPoint = 'confluence' | 'atlassian-home';
